import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { trackLink } from '../../lib/analytics-helper';
import Page from '../../lib/page';

const cobrand = Page.getCountry();

class RelatedArticles extends Component {
  constructor(props) {
    super(props);

    this.renderArticleListItem = this.renderArticleListItem.bind(this);
  }

  fptiTracking(faqId) {
    const upfrontFAQId = this.props.upfront;
    trackLink({ id: `${this.props.FPTIPageName}`, link: `${this.props.link}${upfrontFAQId}|${faqId}` });
  }

  renderArticleListItem(articleInfo) {
    let href;
    if (!this.props.community) {
      href = `${this.props.relatedRedirectURL}${Page.getFormattedUrlForArticle(articleInfo.articleTitle, articleInfo.articleId)}`;
    } else {
      href = articleInfo.link;
    }
    return (
      <li key={articleInfo.articleId}>
        <p>
          <a
            className="related-articles-link"
            href={href} target={this.props.target}
            rel="noopener noreferrer"
            onClick={() => this.fptiTracking(articleInfo.articleId)}
          >
            {articleInfo.articleTitle}
          </a>
        </p>
      </li>
    );
  }

  renderArticleList() {
    const { relatedArticles } = this.props; // eslint-disable-line react/prop-types
    const displayNumber = this.props.displayNumber;
    const displayList = relatedArticles && relatedArticles.slice(0, displayNumber);
    const articleList = displayList.map(this.renderArticleListItem);
    if (articleList.length) {
      return <ul className="related-article-list">{articleList}</ul>;
    }
    return null;
  }
  render() {
    return (
      <div className="related-articles-component">
        <p className="title">
          {this.props.header}
        </p>
        <div className="contents">
          {this.renderArticleList()}
        </div>
      </div>
    );
  }
}

RelatedArticles.defaultProps = {
  relatedArticles: [],
  displayNumber: 2,
  header: '',
  upfront: '',
  FPTIPageName: 'contactUsPage',
  target: '_blank',
  relatedRedirectURL: `/${cobrand}/selfhelp/article/`,
  community: false,
  link: 'smarthelp-related-article',
};

RelatedArticles.propTypes = {
  displayNumber: PropTypes.number,
  header: PropTypes.string,
  upfront: PropTypes.string,
  FPTIPageName: PropTypes.string,
  target: PropTypes.string,
  relatedRedirectURL: PropTypes.string,
  community: PropTypes.bool,
  link: PropTypes.string,
};

export default RelatedArticles;
